var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3Hover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon3-hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon3-hover"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,0 C77.6142375,-5.07265313e-15 100,22.3857625 100,50 C100,77.6142375 77.6142375,100 50,100 C22.3857625,100 3.38176876e-15,77.6142375 0,50 C-3.38176876e-15,22.3857625 22.3857625,5.07265313e-15 50,0 Z",
    id: "icon-bg",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3025,32.6000368 C65.0405,32.6000368 70,38.8050368 70,47.1560368 C70,53.6365368 64.136,60.7735368 52.5825,68.7930368 C51.0289212,69.8689387 48.9710788,69.8689387 47.4175,68.7930368 C35.864,60.7735368 30,53.6365368 30,47.1560368 C30,38.8050368 34.9595,32.6000368 42.6975,32.6000368 C45.492,32.6000368 47.3875,33.5765368 50,35.7920368 C52.613,33.5770368 54.508,32.6000368 57.3025,32.6000368 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFA516",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3Hover);
export default __webpack_public_path__ + "static/media/icon3-hover.svg";
export { ForwardRef as ReactComponent };